import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const font = "'Inria Serif', serif";

export default function VenueVivaCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('Connecting your Viva Wallet account...');
  const [hasError, setHasError] = useState(false);
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const getStoredToken = useCallback(() => localStorage.getItem('token'), []);

  const finalize = useCallback(async () => {
    const venueId = searchParams.get('venueId');
    const providerError = searchParams.get('error_description') || searchParams.get('error');
    if (providerError) {
      setHasError(true);
      setStatus(decodeURIComponent(providerError));
      return;
    }

    if (!venueId) {
      setHasError(true);
      setStatus('Missing venue connection details.');
      return;
    }

    try {
      const token = getStoredToken();
      if (!token) {
        setHasError(true);
        setStatus('Your session expired before Viva Wallet could finish connecting. Please sign in again and retry.');
        return;
      }
      await axios.post(
        `${API}/viva/finalize-connection`,
        { venue_id: venueId },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setStatus('Viva Wallet connected successfully. Redirecting...');
      setTimeout(() => navigate('/venue/settings/payouts', { replace: true }), 1400);
    } catch (error) {
      setHasError(true);
      setStatus(error.response?.data?.detail || 'Failed to finalize Viva Wallet connection.');
    }
  }, [getStoredToken, navigate, searchParams]);

  useEffect(() => {
    finalize();
  }, [finalize]);

  return (
    <div className="app-shell" data-testid="venue-viva-callback-page" style={{ minHeight: '100vh', backgroundColor: 'var(--app-bg)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}>
      <img src="/allure-logo.png" alt="Allure" style={{ width: 110, height: 98, objectFit: 'contain', marginBottom: 18 }} />
      <h1 style={{ fontFamily: font, fontSize: 28, fontWeight: 700, color: 'var(--text)', textAlign: 'center', margin: 0 }}>Viva Wallet</h1>
      <p data-testid="venue-viva-callback-status" style={{ fontFamily: font, fontSize: 20, color: 'var(--text)', textAlign: 'center', lineHeight: 1.1, margin: '18px 0 0', maxWidth: 340 }}>{status}</p>
      {hasError ? (
        <button
          data-testid="venue-viva-callback-back-button"
          onClick={() => navigate('/venue/settings/payouts', { replace: true })}
          style={{ marginTop: 18, border: 'none', borderRadius: 16, padding: '14px 22px', background: 'var(--status-success-text)', color: '#FFFFFF', fontFamily: font, fontSize: 20, fontWeight: 700, cursor: 'pointer' }}
        >
          Back to payouts
        </button>
      ) : null}
    </div>
  );
}